var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlIconAquilone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-assets",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "fl-logo",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h192v192H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC1C6",
    d: "M108.93 128.87L66.85 184h21.63c3.65.03 7.12-1.59 9.37-4.52l38.51-50.34-27.42-.25-.01-.02zM18.97 144c-3.59-.03-6.98 1.58-9.2 4.58L8 150.97l11.48 2.82 6.64 9.36L40.23 144H18.97z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADCE0",
    d: "M88.38 184c-3.64-.03-7.05-1.65-9.24-4.59l-22.62-30.53c-2.19-2.95-5.6-4.84-9.24-4.88H20c3.64.03 7.05 1.68 9.24 4.62l22.62 30.53c2.19 2.95 5.6 4.81 9.24 4.85h27.28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M20.01 77.97c.08-1.36.39-2.71.94-3.98.65-1.5 1.61-2.89 2.89-4.06l64.14-58.81A11.79 11.79 0 0 1 95.99 8l3.98 36.03L95.99 72l-31.96 8.07-44.02-2.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#669DF6",
    d: "M171.97 77.97a11.75 11.75 0 0 0-.94-3.98c-.65-1.5-1.61-2.89-2.89-4.06L104 11.12A11.784 11.784 0 0 0 96 8v64l36.16 8.07 39.81-2.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5BB974",
    d: "M171.98 77.97l-36.77-3.22L96 72l-4 24s4 23.27 4 24c0 .54 15.98 3.9 15.98 3.9l29.3-1.14 6.08-7.92 22.19-28.94c1.81-2.34 2.6-5.17 2.43-7.93z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M20.02 77.97c-.17 2.76.62 5.59 2.43 7.94l22.19 28.94 6.08 7.92 25.23 1.33L96 120V72l-75.98 5.97z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M96 120c-2.29 0-45.29 2.77-45.29 2.77l35.88 46.78c2.37 3.1 5.89 4.64 9.41 4.64l4.06-34.15c0 .01-3.11-20.04-4.06-20.04z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCC934",
    d: "M96 174.19c3.52 0 7.04-1.55 9.41-4.64l35.88-46.78L96 120v54.19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlIconAquilone);
export default __webpack_public_path__ + "static/media/fl-icon-aquilone.a98d99e22379314463630e75f249f1ee.svg";
export { ForwardRef as ReactComponent };